import { TeButton, TeContainerSlim } from '@topcon/tuicl-react';
import styled from 'styled-components';

import { getThemeColorValue } from '../../../providers/theme/theme.index';

export interface DivisionFilterButtonProps {
  /** The Division filter drawer is currently open (highlights the button). */
  isOpen: boolean;
  /** At least one Division is selected, i.e. `selectedDivisionIds.length > 0`
   * (shows the active-filter dot). */
  hasActiveFilter: boolean;
  onClick: () => void;
}

const FilterButtonWrapper = styled(TeContainerSlim)`
  position: relative;
`;

// Figma 5930:16226: a solid red 8px dot overlapping the bottom-right of the
// 32px button's funnel glyph.
const FilterActiveDot = styled.span`
  position: absolute;
  right: 6px;
  bottom: 6px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${getThemeColorValue('icon.error.primary')};
  pointer-events: none;
`;

/**
 * Division filter drawer trigger shared by Customers (02) and Invites (03):
 * a `filter_alt` icon button, highlighted while the drawer is open, with a
 * small dot when a Division is selected (PRD 02 "Division rollup": "The
 * filter button shows the active-filter dot when a Division is selected").
 * Render only when `hasDivisions` — same gate as `DivisionQuickFilter`.
 */
export default function DivisionFilterButton({
  isOpen,
  hasActiveFilter,
  onClick,
}: DivisionFilterButtonProps) {
  return (
    <FilterButtonWrapper>
      <TeButton
        size="s"
        icon="filter_alt"
        backgroundColor={isOpen ? 'background.selected' : 'background.primary'}
        iconColor="icon.primary"
        teclick={onClick}
      />
      {hasActiveFilter && <FilterActiveDot />}
    </FilterButtonWrapper>
  );
}
